/**
 * True when this render is a browser history return, not the first load
 * or a refresh. location.key is "default" only for the initial entry.
 */
export const isHistoryBack = (navigationType, locationKey) =>
  navigationType === 'POP' && locationKey !== 'default';
